import React from 'react';
import { OFFER_ANCHOR, PRODUCT_NAME, SUPPORT_EMAIL } from './constants';
export function Footer() {
  return <footer className="bg-pf-navyDeep px-3 py-2.5 text-center text-white/70 sm:px-4" data-id="element-80" data-mp="3ggarlxr3gh6i">
      <p className="font-display text-[10.5px] font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-81" data-mp="32oe0nx15wdbp">
        © 2026 {PRODUCT_NAME} — All Rights Reserved.
      </p>
      <p className="mx-auto mt-0.5 max-w-3xl text-[10.5px] font-medium leading-snug sm:text-xs" data-id="element-82" data-mp="36n3gdw9oa6yi">
        This system provides professional educational information for qualified fitness
        professionals. It does not provide medical advice, diagnosis, treatment, rehabilitation or
        individualized healthcare guidance. Exercise decisions should consider each client’s
        individual circumstances, professional scope, relevant contraindications and healthcare
        guidance when appropriate.
      </p>
      <nav className="mt-1 flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[10.5px] font-bold sm:text-xs" data-id="element-83" data-mp="2ey0bce9yoskt">
        <a href={OFFER_ANCHOR} className="transition-colors duration-150 ease-out hover:text-pf-coral" data-id="element-84" data-mp="3lalfndz543tf">
          Terms &amp; Conditions
        </a>
        <span aria-hidden="true" data-id="element-85" data-mp="3v89d4bo4rpfa">•</span>
        <a href={OFFER_ANCHOR} className="transition-colors duration-150 ease-out hover:text-pf-coral" data-id="element-86" data-mp="3v9az3b6opwbs">
          Privacy Policy
        </a>
        <span aria-hidden="true" data-id="element-87" data-mp="828mc4dy418m">•</span>
        <a href={OFFER_ANCHOR} className="transition-colors duration-150 ease-out hover:text-pf-coral" data-id="element-88" data-mp="81785r1muymo">
          Contact
        </a>
      </nav>
      <p className="mt-0.5 text-[10.5px] font-medium sm:text-xs" data-id="element-89" data-mp="hrigdpscntzd">
        Support:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="font-bold text-pf-coral transition-colors duration-150 ease-out hover:text-white" data-id="element-90" data-mp="curzx1cmuwdf">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}